module.exports = __webpack_public_path__ + "img/icon-my-transfers.e4761259.svg";